const allFlights = [
  { name: "almaty-dushanbe", path: "almaty-dushanbe" },
  { name: "astana-dushanbe", path: "astana-dushanbe" },
  { name: "bishkek-dushanbe", path: "bishkek-dushanbe" },
  { name: "delhi-dushanbe", path: "delhi-dushanbe" },
  { name: "dushanbe-almaty", path: "dushanbe-almaty" },
  { name: "dushanbe-astana", path: "dushanbe-astana" },
  { name: "dushanbe-bishkek", path: "dushanbe-bishkek" },
  { name: "dushanbe-delhi", path: "dushanbe-delhi" },
  { name: "dushanbe-dubai", path: "dushanbe-dubai" },
  { name: "dushanbe-ekaterinburg", path: "dushanbe-ekaterinburg" },
  { name: "dushanbe-istanbul", path: "dushanbe-istanbul" },
  { name: "dushanbe-jeddah", path: "dushanbe-jeddah" },
  { name: "dushanbe-kazan", path: "dushanbe-kazan" },
  { name: "dushanbe-khujand", path: "dushanbe-khujand" },
  { name: "dushanbe-kulyab", path: "dushanbe-kulyab" },
  { name: "dushanbe-moscow", path: "dushanbe-moscow" },
  { name: "dushanbe-munich", path: "dushanbe-munich" },
  { name: "dushanbe-orenburg", path: "dushanbe-orenburg" },
  { name: "dushanbe-samarkand", path: "dushanbe-samarkand" },
  { name: "dushanbe-saintpetersburg", path: "dushanbe-saintpetersburg" },
  { name: "dushanbe-tashkent", path: "dushanbe-tashkent" },
  { name: "dushanbe-urgench", path: "dushanbe-urgench" },
  { name: "dushanbe-zhukovsky", path: "dushanbe-zhukovsky" },
  { name: "ekaterinburg-dushanbe", path: "ekaterinburg-dushanbe" },
  { name: "istanbul-dushanbe", path: "istanbul-dushanbe" },
  { name: "jeddah-dushanbe", path: "jeddah-dushanbe" },
  { name: "kazan-dushanbe", path: "kazan-dushanbe" },
  { name: "kazan-khujand", path: "kazan-khujand" },
  { name: "khujand-dushanbe", path: "khujand-dushanbe" },
  { name: "khujand-kazan", path: "khujand-kazan" },
  { name: "khujand-surgut", path: "khujand-surgut" },
  { name: "khujand-urgench", path: "khujand-urgench" },
  { name: "khujand-zhukovsky", path: "khujand-zhukovsky" },
  { name: "kulyab-dushanbe", path: "kulyab-dushanbe" },
  { name: "moscow-dushanbe", path: "moscow-dushanbe" },
  { name: "munich-dushanbe", path: "munich-dushanbe" },
  { name: "orenburg-dushanbe", path: "orenburg-dushanbe" },
  { name: "samarkand-dushanbe", path: "samarkand-dushanbe" },
  { name: "saintpetersburg-dushanbe", path: "saintpetersburg-dushanbe" },
  { name: "surgut-khujand", path: "surgut-khujand" },
  { name: "tashkent-dushanbe", path: "tashkent-dushanbe" },
  { name: "urgench-dushanbe", path: "urgench-dushanbe" },
  { name: "urgench-khujand", path: "urgench-khujand" },
  { name: "zhukovsky-dushanbe", path: "zhukovsky-dushanbe" },
  { name: "zhukovsky-khujand", path: "zhukovsky-khujand" },
];

const importFlightData = async fileName => {
  try {
    const flightData = await import(`./flightsInfoJsons/${fileName}.json`);
    return flightData?.default || null;
  } catch (error) {
    console.error(`Error importing flight data from ${fileName}:`, error);
    return null;
  }
};

export const getAllFlights = async () => {
  const flights = [];

  for (const flight of allFlights) {
    const flightData = await importFlightData(flight.path);

    if (flightData) {
      flights.push(flightData);
    }
  }

  return flights;
};

export const getFlightsMiniInfo = async (limit = 0, isRandom = true) => {
  let processedFlights = [...allFlights];

  if (isRandom) {
    processedFlights = processedFlights.sort(() => Math.random() - 0.5);
  }

  if (limit > 0) {
    processedFlights = processedFlights.slice(0, limit);
  }

  const result = [];

  for (const flight of processedFlights) {
    if (!flight.path) {
      console.warn(`Flight missing path:`, flight);
      continue;
    }

    const flightData = await importFlightData(flight.path);

    if (flightData?.key && flightData?.name) {
      result.push({
        key: flightData.key,
        name: flightData.name,
      });
    }
  }

  return result;
};
